import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { MmsParams, MmsResponse } from 'src/apis/iip-service/types';
import type { IipServiceRequest } from 'src/apis/iip-service/use-iip-service';
import { useAxios, type Successful } from 'src/hooks/use-axios';

type HookProps = {
  iipService: Successful<IipServiceRequest>;
  params: MmsParams;
};

type RequestOptions = {
  iipService: Successful<IipServiceRequest>;
  params: MmsParams;
};

export const useMms = ({ iipService, params }: HookProps) => {
  const request = useAxios(
    (axios, baseConfig, { iipService, params }: RequestOptions) => {
      const url: string = urlTemplate
        .parse(iipService.response.data._links.maintenanceMessages.href)
        .expand({});

      return axios.request<MmsResponse>({
        ...baseConfig,
        url,
        params,
      });
    },
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    request.execute({
      iipService,
      params,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iipService.response, params]);

  return request;
};

export type MmsRequest = ReturnType<typeof useMms>;
